export default function HomeStrip1() {
    return (
        <div className="relative">
            <p className="absolute top-[19%] bg-amber-300 right-[49%] px-2 rounded-sm">TourTravel</p>
            <img src="https://images.troll.is/v1/troll/aIEhsFGsbswqTL4j_2025banner.png?auto=format%2Ccompress&width=2048" className="w-[82vw] flex justify-center mx-[8%] my-[5%]"></img>
        </div>
    )
}